import { render, staticRenderFns } from "./DataHistory.vue?vue&type=template&id=7b5cabea&scoped=true&"
import script from "./DataHistory.vue?vue&type=script&lang=js&"
export * from "./DataHistory.vue?vue&type=script&lang=js&"
import style0 from "./DataHistory.vue?vue&type=style&index=0&id=7b5cabea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5cabea",
  null
  
)

export default component.exports